import React from 'react';
import { Carousel, Icon, Modal } from 'antd';
import styled from 'styled-components/macro';

const PrevArrowContainer = styled.span`
  display: block;
  position: absolute;
  top: 50%;
  left: 0px;
  color: ${props => props.theme.color.lighterGrey};
  z-index: 999;
  font-size: 32px;
  margin-left: -32px;
  text-align: center;

  &:hover {
    cursor: pointer;
  }
`;

const PrevArrow = ({ onClick }) => (
  <PrevArrowContainer>
    <Icon type="left" onClick={onClick} />
  </PrevArrowContainer>
);

const NextArrowContainer = styled.span`
  display: block;
  position: absolute;
  top: 50%;
  right: 0px;
  color: ${props => props.theme.color.ligtherGrey};
  z-index: 999;
  font-size: 32px;
  margin-right: -32px;
  text-align: center;

  &:hover {
    cursor: pointer;
  }
`;

const NextArrow = ({ onClick }) => (
  <NextArrowContainer>
    <Icon type="right" onClick={onClick} />
  </NextArrowContainer>
);

const CloseIcon = styled(Icon)`
  margin-left: 20px;

  &:hover {
    cursor: pointer;
  }
`;

const ModalCarousel = styled.div`
  text-align: center;
  height: 83vh;
  line-height: 83vh;
  background: ${props => props.theme.color.darkestBlack};
  overflow: hidden;
  margin-bottom: -10px;
`;

const ModalCarouselImage = styled.img`
  display: inline-block !important;
  width: 100%;
  height: auto;
  margin: auto;
  max-width: 100%;
  max-height: 70vh;
  vertical-align: middle;

  @media (min-width: 1200px) {
    width: auto;
    height: 100%;
  }
`;

const ImageGallery = ({ photos, visible, onCloseImageGallery }) => (
  <Modal
    width="90%"
    closeIcon={<CloseIcon type="close" onClick={onCloseImageGallery} />}
    bodyStyle={{ height: '90vh', paddingLeft: '32px', paddingRight: '32px' }}
    centered
    visible={visible}
    onCancel={onCloseImageGallery}
    footer={null}
  >
    <div>
      <Carousel infinite={true} arrows={true} prevArrow={<PrevArrow />} nextArrow={<NextArrow />}>
        {photos.length > 0 &&
          photos.map((photo, index) => (
            <div key={index}>
              <ModalCarousel>
                <ModalCarouselImage alt={`unit-detail-${index}`} src={photo} />
              </ModalCarousel>
            </div>
          ))}
      </Carousel>
    </div>
  </Modal>
);

export default ImageGallery;